import { FormStateContext } from "../providers/FormStateProvider";
import { useContext } from "react";

export default function useFormState() {
  return useContext(FormStateContext);
}
